import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { localizeDate } from '@/utils/date';
import { getFileURL } from '@/utils/file-uploads';
import { get } from 'lodash';
export default {
  name: 'CoreVirtualDeviceDriverList',
  props: {
    hideHeader: {
      type: Boolean,
      default: false
    },
    smartGroupId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      selectedAccounts: [],
      accountFilterIsReady: false,
      cacheBuster: 0,
      itemsInDeletion: [],
      itemIdToBeDeleted: null
    };
  },
  computed: {
    ...mapState('app', ['permissions', 'color']),
    isVirtualDeviceDriverManager() {
      return this.permissions['DeviceDriver.manage'];
    },
    tableHeaders() {
      const headers = [{
        text: this.$i18n_t('DeviceDriver.list.table.headers.id'),
        value: 'id'
      }, {
        value: 'image',
        sortable: false,
        isAvatarImage: true
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.tenant'),
        value: 'Tenant.name'
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.parser'),
        value: 'parser',
        sortable: false
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.createdAt'),
        value: 'createdAt'
      }];
      if (this.isVirtualDeviceDriverManager) {
        headers.push({
          text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
          isButtons: true,
          align: 'center',
          sortable: false,
          buttons: [{
            icon: 'fal fa-edit',
            color: this.color,
            onClick: item => {
              this.$router.push(this.getSingleDriverUrl(item.id));
            }
          }, {
            icon: 'fal fa-trash-alt',
            color: this.color,
            onClick: item => {
              this.onDeleteClick(item);
            },
            loading: item => this.itemsInDeletion.includes(item.id)
          }]
        });
      }
      return headers;
    },
    headerButtons() {
      return [{
        title: this.$i18n_t('DeviceDriver.list.header.buttons.copyPaste'),
        icon: 'fal fa-copy',
        action: 'copyPaste'
      }];
    }
  },
  methods: {
    localizeDate,
    getSingleDriverUrl(id) {
      return `/virtual-device-drivers/${id}`;
    },
    async fetchItems(options) {
      const {
        search,
        page,
        perPage,
        sortBy,
        sortDirection,
        selectedAccounts
      } = options;
      const accountIds = selectedAccounts.map(account => account.id);
      const result = await ApiService.virtualDeviceDrivers.fetch({
        limit: perPage,
        offset: perPage * (page - 1),
        sortBy: sortBy,
        sortDesc: sortDirection === 'desc',
        search,
        accountIds,
        smartGroupId: this.smartGroupId
      });
      return {
        items: result.deviceDrivers.map(item => {
          let accountName = item.accountId;
          if (item.account && item.account.name) {
            accountName = item.Tenant.name;
          }
          return {
            ...item,
            name: accountName,
            image: getFileURL(item.image, 2),
            parser: this.parserListToTranslationKey(item.versions),
            createdAt: this.localizeDate(item.createdAt)
          };
        }),
        total: result.totalCount
      };
    },
    imageURL(image) {
      let imageUri = image;
      if (!imageUri) {
        return '';
      }
      if (!imageUri.startsWith('/')) {
        imageUri = `/${imageUri}`;
      }
      return image ? `${location.origin}/api/v1/upload/v2${imageUri}` : '';
    },
    parserListToTranslationKey(parsers) {
      const getDisplayStringForOne = parser => {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes')[get(parser, 'parser.type', '__undefined__')] || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes.unset');
      };
      if (!parsers) {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes.unset');
      }
      return parsers.map(parser => getDisplayStringForOne(parser)).join(', ');
    },
    onDeleteClick(item) {
      this.itemIdToBeDeleted = item.id;
    },
    async onDeleteItemConfirm() {
      const itemId = this.itemIdToBeDeleted;
      this.itemIdToBeDeleted = null;
      try {
        this.itemsInDeletion.push(itemId);
        await ApiService.virtualDeviceDrivers.deleteOne(itemId);
        this.$snack(this.$i18n_t('DeviceDriver.list.deleteSuccess'), 'success');
        this.cacheBuster += 1;
      } catch (error) {
        const errorCode = get(error, 'response.data.message');
        const mappedMessage = errorCode && this.$i18n_t(`Error.${errorCode}`);
        this.$snack(mappedMessage || this.$i18n_t('DeviceDriver.list.deleteError'), 'error');
      } finally {
        this.itemsInDeletion = this.itemsInDeletion.filter(id => id !== itemId);
      }
    }
  }
};